/** Canonical seed role IDs — mirrors admin-api role-seeds.js. */
export const CANONICAL_ROLE_ID_BY_KEY: Record<string, string> = {
  "super-admin": "ROLE-001",
  admin: "ROLE-002",
  "tech-support": "ROLE-003",
  "account-manager": "ROLE-004",
  "music-director": "ROLE-005",
  "voice-over": "ROLE-006",
  licensing: "ROLE-007",
  developer: "ROLE-008",
  support: "ROLE-009",
  operations: "ROLE-010",
  "human-resources": "ROLE-011",
  finance: "ROLE-012",
};

/** Prefer API roleId; fall back to canonical seed map when staging API is not yet redeployed. */
export function resolveCatalogRoleId(role: {
  roleId?: string | null;
  roleKey: string;
}): string {
  const fromApi = (role.roleId || "").trim();
  if (fromApi) return fromApi;
  return CANONICAL_ROLE_ID_BY_KEY[role.roleKey] || "";
}
